import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Box, Break, Card, Grid, Text } from "~/components-shared";
import { useTranslation } from "react-i18next";
import styled, { useTheme } from "styled-components";
import TopicFootprintSmall from "~/components/TopicFootprintSmall";
const StyledGrid = styled(Grid)`
  overflow: hidden;
  position: relative;
`;
const StyledBreakText = styled(Text)`
  vertical-align: top;
`;
const Scrollable = styled.div`
  overflow: auto;
`;
const TrendOverviewFootprintsCard = _ref => {
  let {
    report,
    footprints,
    ...rest
  } = _ref;
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Card, _extends({
    s: {
      p: 0
    },
    fullWidth: true
  }, rest), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mb: 3
    }
  }, t("TrendOverviewFootprintsCard.highlights")), footprints.length ? /*#__PURE__*/React.createElement(Scrollable, null, /*#__PURE__*/React.createElement(StyledGrid, {
    cols: 1,
    template: "1fr",
    gap: 3,
    fullWidth: true,
    s: {
      mb: 6,
      pt: 2,
      pr: 5
    }
  }, footprints.length < 10 ? footprints.map(footprint => /*#__PURE__*/React.createElement(TopicFootprintSmall, {
    key: footprint.id,
    footprint: footprint
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, footprints.slice(0, 5).map(footprint => /*#__PURE__*/React.createElement(TopicFootprintSmall, {
    key: footprint.id,
    footprint: footprint
  })), footprints.length > 10 && /*#__PURE__*/React.createElement(Box, {
    s: {
      pl: 15,
      pr: 5,
      pb: 8
    }
  }, /*#__PURE__*/React.createElement(Break, null, /*#__PURE__*/React.createElement(StyledBreakText, {
    weight: "semiBold",
    fontSize: 4,
    color: colors.text.primary
  }, "\xB7\xB7\xB7 ", footprints.length - 10, " Footprints in between \xB7\xB7\xB7"))), footprints.length > 5 && footprints.slice(-5).map(footprint => /*#__PURE__*/React.createElement(TopicFootprintSmall, {
    key: footprint.id,
    footprint: footprint
  }))))) : /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 5,
    align: "center",
    s: {
      mt: 8
    },
    display: "block"
  }, t("TrendOverviewFootprintsCard.noFootprintsFound")));
};
export default TrendOverviewFootprintsCard;